import axios from 'axios';
import CryptoJS from 'crypto-js';
import { HTTP } from './services';
import { uniq } from 'lodash';
import { authenticate } from '../Recoil-State';
import { setRecoil, getRecoil } from "recoil-nexus";
import { ApiBaseURL, BaseURL, AppEnv, GenericApiBaseURL } from '../environment';
import { SourceParams } from '../Constant';
import logoutServices from './logout.services';


class Authentication {

    languageList(list, defaultLangCode) {
        let codes = [];
        let langList = (list && [...list, ...codes]) || [];
        let isExist = langList.includes(defaultLangCode);

        if (!isExist) {
            langList = [...langList, defaultLangCode];
        }

        return uniq(langList);
    }
    /**
     * Update active user login details on server in  background
     */
    async userlog (user) {
        try {
            const req = {
                applicationName: user.applicationName  ,
                email:  user.email,
                firstName:  user.firstName,
                lastName: user.lastName,
                loginStatus: 'success' ,
            };
            const response = await HTTP.POST(`${GenericApiBaseURL}/userlog`, req);
            return response;
        }
        catch (e) {
            console.error('Error:', e.toString());
        }
    }

    // async getPermission(users, interroList = []) {

    //     try {
    //         let interroStr = interroList.join(",");
    //         //if (users && !users.memberOf && !interroStr) { return false; }
    //         let groups = (users.memberOf && users.memberOf.replace('[', '').replace(']', ''));
    //         if (interroStr) {
    //             groups = groups + "," + interroStr;
    //         }
            
    //         // need to redirect home if empty 
    //         // if ( !groups) {
    //         //     logoutServices.logout(); 
    //         // } else {
            
    //         const response = await axios.get(`generic/authorize-new?groups=${groups}`);
    //         let result = response && response.data;
    //         let { marketCode, allLangCodes, defaultLangCode} = result.responseObject;
    //         let marketCodeListing = marketCode.split(',');
    //         let defaultMarketCode = marketCodeListing && (marketCodeListing && marketCodeListing[0]);

    //         let Obj = {
    //             ...result.responseObject,
    //             defaultMarketCode,
    //             marketCodeListing,
    //             allLangCodes: this.languageList(allLangCodes, defaultLangCode)
    //         }
    //         return Obj;
    //         //}
    //     }
    //     catch (e) {
    //         console.error('Error during get permisssion:', e.toString());
    //     }
    // }

    async getPermission(users, interroList = []) {

        try {
            let interroStr = interroList.join(",");
            //if (users && !users.memberOf && !interroStr) { return false; }
            let groups = (users.memberOf && users.memberOf.replace('[', '').replace(']', ''));
            if (interroStr) {
                groups = groups + "," + interroStr;
            }
            
            // need to redirect home if empty 
            // if ( !groups) {
            //     logoutServices.logout(); 
            // } else {
            let data = {
                "groups": typeof groups === "string"
                    ? groups.split(",").map(item => item.trim()).filter(Boolean)
                    : groups || [],
                "countryCode": users.countryCode || '',
                "jobTtitle": users.jobTitle || '',
                "isAppSpecific": false
            }
            
            const response = await axios.post(`${GenericApiBaseURL}/authorize`, data);
            let result = response && response.data;
            let { marketCode, allLangCodes, defaultLangCode} = result.responseObject;
            let marketCodeListing = marketCode.split(',');
            let defaultMarketCode = marketCodeListing && (marketCodeListing && marketCodeListing[0]);

            let Obj = {
                ...result.responseObject,
                defaultMarketCode,
                marketCodeListing,
                allLangCodes: this.languageList(allLangCodes, defaultLangCode)
            }
            return Obj;
            //}
        }
        catch (e) {
            console.error('Error during get permisssion:', e.toString());
        }
    }
    
    async refreshToken() {
        try {
            let response = await fetch(`${ApiBaseURL}/refreshToken`).then(response => response.json());
            if (response && response.access_token) {
                let auth = await getRecoil(authenticate);
                auth.token = await response.access_token;
                await setRecoil(authenticate, auth);
            }
            return (response && response.access_token) || null;
        }
        catch (e) {
            console.error('error during refersh token', e.toString());
        }
    }

    async decryptData(data) {
        try {
            if (!data) { return false; }
            const response = await HTTP.POST(`${BaseURL}/getDecryptData`, { encryptedData: data });
            // Validate response
            if (!response) {
                console.error('decryptData: No response from server');
                return false;
            }
            if (response.error) {
                console.error('decryptData: Server error -', response.error);
                return false;
            }
            return response.data;
        }
        catch (e) {
            console.log('Decryption failed:', e.toString());
            return false;
        }
    }

    createUserInfo(response) {
        let userInfo ={};

        if (response && response.code) {
            let { code, secrets } = response;

            userInfo = {
                firstName: code['custom:firstName'],
                lastName: code['custom:lastName'],
                userName: code['custom:prid'],
                fullName: `${code['custom:firstName']} ${code['custom:lastName']}`,
                email: code['email'],
                countryCode : code['custom:countryCode'],
                jobTitle : code['custom:jobTitle'],
                secrets : secrets
            }
            // need to redirect home if empty 
            if (code && code['custom:memberOf']) {
                userInfo = { ...userInfo, memberOf: code['custom:memberOf'] };
            }
        }

        if (response && response.token) {
            userInfo = { ...userInfo, token: response.token, env:AppEnv ==='poc' ? 'poc': response.env}
        }
        return userInfo;
    }
    checkSourceFromUrl =() => {
        let { search } =  window.location;
        let Params = new URLSearchParams(search);
        let source = Params.get('source');
        let data =  Params.get('data')
        return (source &&  SourceParams.indexOf(source) >=0) ? data : false;


    }
    async getTokenAsync() {
        try {
            let userInfo  ={};
            let isSource = this.checkSourceFromUrl();
            if ( isSource ) {
                let response = await this.decryptData(isSource);
                userInfo = await this.createUserInfo(response);
            } else {
                let response = await fetch(`${BaseURL}/admin?appName=fxhub&appEnv=${AppEnv}`).then(response => response.json());
                userInfo = await this.createUserInfo(response);
            }

            // logout if token is not valid:
            if (userInfo && !userInfo.token) {
                logoutServices.logout();
            }
            return (userInfo.token ? userInfo : false);
        }
        catch (e) {
            console.error('Error during get token:', e.toString());
        }
    }
   
}

export const authentication = new Authentication();